var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1677",
    "data-name": "Grupo 1677",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_35",
    "data-name": "Elipse 35",
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#ffc0d4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin-icon-1",
    transform: "translate(8.455 8.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "linkedin-icon-1-2",
    "data-name": "linkedin-icon-1",
    d: "M0,6.822A1.7,1.7,0,0,1,.562,5.515,2.077,2.077,0,0,1,2.022,5a2.015,2.015,0,0,1,1.428.507,1.775,1.775,0,0,1,.562,1.362,1.658,1.658,0,0,1-.546,1.267,2.081,2.081,0,0,1-1.477.523H1.974A1.979,1.979,0,0,1,.546,8.136,1.744,1.744,0,0,1,0,6.822Zm.209,13.86V10.1H3.772V20.682Zm5.537,0H9.309V14.773a2.253,2.253,0,0,1,.128-.855,2.3,2.3,0,0,1,.682-.911,1.759,1.759,0,0,1,1.148-.372q1.8,0,1.8,2.392v5.655h3.563V14.615A5.054,5.054,0,0,0,15.5,11.059a3.858,3.858,0,0,0-2.969-1.212,3.654,3.654,0,0,0-3.226,1.758v.032H9.293l.016-.032V10.1H5.746q.032.507.032,3.152T5.746,20.682Z",
    transform: "translate(0 -5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIconColor);
export default __webpack_public_path__ + "static/media/linkedin_icon_color.a63899b30632973c3bb85eb75890bf2c.svg";
export { ForwardRef as ReactComponent };